/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClaimFinancialSummary,
  ClaimTransaction,
  CreateTransactionRequest,
  ErrorEnvelope,
  Problem,
  TransactionListResponse,
  UpdateTransactionRequest,
  UploadCheckFileRequest,
  UpsertFinancialSummaryRequest,
} from '../models/index';
import {
    ClaimFinancialSummaryFromJSON,
    ClaimFinancialSummaryToJSON,
    ClaimTransactionFromJSON,
    ClaimTransactionToJSON,
    CreateTransactionRequestFromJSON,
    CreateTransactionRequestToJSON,
    ErrorEnvelopeFromJSON,
    ErrorEnvelopeToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    TransactionListResponseFromJSON,
    TransactionListResponseToJSON,
    UpdateTransactionRequestFromJSON,
    UpdateTransactionRequestToJSON,
    UploadCheckFileRequestFromJSON,
    UploadCheckFileRequestToJSON,
    UpsertFinancialSummaryRequestFromJSON,
    UpsertFinancialSummaryRequestToJSON,
} from '../models/index';

export interface CreateClaimTransactionRequest {
    claimId: number;
    createTransactionRequest: CreateTransactionRequest;
}

export interface DeleteClaimTransactionRequest {
    claimId: number;
    id: number;
}

export interface DeleteTransactionCheckFileRequest {
    claimId: number;
    id: number;
}

export interface GetClaimFinancialSummaryRequest {
    claimId: number;
}

export interface GetClaimTransactionRequest {
    claimId: number;
    id: number;
}

export interface GetClaimTransactionsRequest {
    claimId: number;
}

export interface GetTransactionCheckFileRequest {
    claimId: number;
    id: number;
}

export interface UpdateClaimTransactionRequest {
    claimId: number;
    id: number;
    updateTransactionRequest: UpdateTransactionRequest;
}

export interface UploadTransactionCheckFileRequest {
    claimId: number;
    id: number;
    uploadCheckFileRequest: UploadCheckFileRequest;
}

export interface UpsertClaimFinancialSummaryRequest {
    claimId: number;
    upsertFinancialSummaryRequest: UpsertFinancialSummaryRequest;
}

/**
 * FinancialsApi - interface
 * 
 * @export
 * @interface FinancialsApiInterface
 */
export interface FinancialsApiInterface {
    /**
     * 
     * @summary Create a new transaction for a claim
     * @param {number} claimId Claim ID
     * @param {CreateTransactionRequest} createTransactionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsApiInterface
     */
    createClaimTransactionRaw(requestParameters: CreateClaimTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTransaction>>;

    /**
     * Create a new transaction for a claim
     */
    createClaimTransaction(requestParameters: CreateClaimTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTransaction>;

    /**
     * 
     * @summary Delete a transaction
     * @param {number} claimId Claim ID
     * @param {number} id Transaction ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsApiInterface
     */
    deleteClaimTransactionRaw(requestParameters: DeleteClaimTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a transaction
     */
    deleteClaimTransaction(requestParameters: DeleteClaimTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete the check file from a transaction
     * @param {number} claimId Claim ID
     * @param {number} id Transaction ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsApiInterface
     */
    deleteTransactionCheckFileRaw(requestParameters: DeleteTransactionCheckFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the check file from a transaction
     */
    deleteTransactionCheckFile(requestParameters: DeleteTransactionCheckFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Returns the claim\'s financial summary (estimate values, policy details & fee agreement). Returns null if no summary exists yet.
     * @summary Get the financial summary for a claim
     * @param {number} claimId Claim ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsApiInterface
     */
    getClaimFinancialSummaryRaw(requestParameters: GetClaimFinancialSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFinancialSummary>>;

    /**
     * Returns the claim\'s financial summary (estimate values, policy details & fee agreement). Returns null if no summary exists yet.
     * Get the financial summary for a claim
     */
    getClaimFinancialSummary(requestParameters: GetClaimFinancialSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFinancialSummary>;

    /**
     * 
     * @summary Get a specific transaction
     * @param {number} claimId Claim ID
     * @param {number} id Transaction ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsApiInterface
     */
    getClaimTransactionRaw(requestParameters: GetClaimTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTransaction>>;

    /**
     * Get a specific transaction
     */
    getClaimTransaction(requestParameters: GetClaimTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTransaction>;

    /**
     * 
     * @summary Get all transactions for a claim
     * @param {number} claimId Claim ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsApiInterface
     */
    getClaimTransactionsRaw(requestParameters: GetClaimTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransactionListResponse>>;

    /**
     * Get all transactions for a claim
     */
    getClaimTransactions(requestParameters: GetClaimTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransactionListResponse>;

    /**
     * 
     * @summary Download the check file for a transaction
     * @param {number} claimId Claim ID
     * @param {number} id Transaction ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsApiInterface
     */
    getTransactionCheckFileRaw(requestParameters: GetTransactionCheckFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Download the check file for a transaction
     */
    getTransactionCheckFile(requestParameters: GetTransactionCheckFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * 
     * @summary Update an existing transaction
     * @param {number} claimId Claim ID
     * @param {number} id Transaction ID
     * @param {UpdateTransactionRequest} updateTransactionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsApiInterface
     */
    updateClaimTransactionRaw(requestParameters: UpdateClaimTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTransaction>>;

    /**
     * Update an existing transaction
     */
    updateClaimTransaction(requestParameters: UpdateClaimTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTransaction>;

    /**
     * 
     * @summary Upload a check image or PDF for a transaction
     * @param {number} claimId Claim ID
     * @param {number} id Transaction ID
     * @param {UploadCheckFileRequest} uploadCheckFileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsApiInterface
     */
    uploadTransactionCheckFileRaw(requestParameters: UploadTransactionCheckFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTransaction>>;

    /**
     * Upload a check image or PDF for a transaction
     */
    uploadTransactionCheckFile(requestParameters: UploadTransactionCheckFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTransaction>;

    /**
     * Upserts the claim\'s financial summary. If it doesn\'t exist, creates it. If it does, updates the provided fields.
     * @summary Create or update the financial summary for a claim
     * @param {number} claimId Claim ID
     * @param {UpsertFinancialSummaryRequest} upsertFinancialSummaryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsApiInterface
     */
    upsertClaimFinancialSummaryRaw(requestParameters: UpsertClaimFinancialSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFinancialSummary>>;

    /**
     * Upserts the claim\'s financial summary. If it doesn\'t exist, creates it. If it does, updates the provided fields.
     * Create or update the financial summary for a claim
     */
    upsertClaimFinancialSummary(requestParameters: UpsertClaimFinancialSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFinancialSummary>;

}

/**
 * 
 */
export class FinancialsApi extends runtime.BaseAPI implements FinancialsApiInterface {

    /**
     * Create a new transaction for a claim
     */
    async createClaimTransactionRaw(requestParameters: CreateClaimTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTransaction>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling createClaimTransaction().'
            );
        }

        if (requestParameters['createTransactionRequest'] == null) {
            throw new runtime.RequiredError(
                'createTransactionRequest',
                'Required parameter "createTransactionRequest" was null or undefined when calling createClaimTransaction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/financials/transactions`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTransactionRequestToJSON(requestParameters['createTransactionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimTransactionFromJSON(jsonValue));
    }

    /**
     * Create a new transaction for a claim
     */
    async createClaimTransaction(requestParameters: CreateClaimTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTransaction> {
        const response = await this.createClaimTransactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a transaction
     */
    async deleteClaimTransactionRaw(requestParameters: DeleteClaimTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling deleteClaimTransaction().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteClaimTransaction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/financials/transactions/{id}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a transaction
     */
    async deleteClaimTransaction(requestParameters: DeleteClaimTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteClaimTransactionRaw(requestParameters, initOverrides);
    }

    /**
     * Delete the check file from a transaction
     */
    async deleteTransactionCheckFileRaw(requestParameters: DeleteTransactionCheckFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling deleteTransactionCheckFile().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTransactionCheckFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/financials/transactions/{id}/check-file`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the check file from a transaction
     */
    async deleteTransactionCheckFile(requestParameters: DeleteTransactionCheckFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTransactionCheckFileRaw(requestParameters, initOverrides);
    }

    /**
     * Returns the claim\'s financial summary (estimate values, policy details & fee agreement). Returns null if no summary exists yet.
     * Get the financial summary for a claim
     */
    async getClaimFinancialSummaryRaw(requestParameters: GetClaimFinancialSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFinancialSummary>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimFinancialSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/financials/summary`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimFinancialSummaryFromJSON(jsonValue));
    }

    /**
     * Returns the claim\'s financial summary (estimate values, policy details & fee agreement). Returns null if no summary exists yet.
     * Get the financial summary for a claim
     */
    async getClaimFinancialSummary(requestParameters: GetClaimFinancialSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFinancialSummary> {
        const response = await this.getClaimFinancialSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific transaction
     */
    async getClaimTransactionRaw(requestParameters: GetClaimTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTransaction>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimTransaction().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getClaimTransaction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/financials/transactions/{id}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimTransactionFromJSON(jsonValue));
    }

    /**
     * Get a specific transaction
     */
    async getClaimTransaction(requestParameters: GetClaimTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTransaction> {
        const response = await this.getClaimTransactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all transactions for a claim
     */
    async getClaimTransactionsRaw(requestParameters: GetClaimTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransactionListResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimTransactions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/financials/transactions`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransactionListResponseFromJSON(jsonValue));
    }

    /**
     * Get all transactions for a claim
     */
    async getClaimTransactions(requestParameters: GetClaimTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransactionListResponse> {
        const response = await this.getClaimTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Download the check file for a transaction
     */
    async getTransactionCheckFileRaw(requestParameters: GetTransactionCheckFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getTransactionCheckFile().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTransactionCheckFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/financials/transactions/{id}/check-file`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download the check file for a transaction
     */
    async getTransactionCheckFile(requestParameters: GetTransactionCheckFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getTransactionCheckFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing transaction
     */
    async updateClaimTransactionRaw(requestParameters: UpdateClaimTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTransaction>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling updateClaimTransaction().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateClaimTransaction().'
            );
        }

        if (requestParameters['updateTransactionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTransactionRequest',
                'Required parameter "updateTransactionRequest" was null or undefined when calling updateClaimTransaction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/financials/transactions/{id}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTransactionRequestToJSON(requestParameters['updateTransactionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimTransactionFromJSON(jsonValue));
    }

    /**
     * Update an existing transaction
     */
    async updateClaimTransaction(requestParameters: UpdateClaimTransactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTransaction> {
        const response = await this.updateClaimTransactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a check image or PDF for a transaction
     */
    async uploadTransactionCheckFileRaw(requestParameters: UploadTransactionCheckFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTransaction>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling uploadTransactionCheckFile().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uploadTransactionCheckFile().'
            );
        }

        if (requestParameters['uploadCheckFileRequest'] == null) {
            throw new runtime.RequiredError(
                'uploadCheckFileRequest',
                'Required parameter "uploadCheckFileRequest" was null or undefined when calling uploadTransactionCheckFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/financials/transactions/{id}/check-file`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadCheckFileRequestToJSON(requestParameters['uploadCheckFileRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimTransactionFromJSON(jsonValue));
    }

    /**
     * Upload a check image or PDF for a transaction
     */
    async uploadTransactionCheckFile(requestParameters: UploadTransactionCheckFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTransaction> {
        const response = await this.uploadTransactionCheckFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upserts the claim\'s financial summary. If it doesn\'t exist, creates it. If it does, updates the provided fields.
     * Create or update the financial summary for a claim
     */
    async upsertClaimFinancialSummaryRaw(requestParameters: UpsertClaimFinancialSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFinancialSummary>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling upsertClaimFinancialSummary().'
            );
        }

        if (requestParameters['upsertFinancialSummaryRequest'] == null) {
            throw new runtime.RequiredError(
                'upsertFinancialSummaryRequest',
                'Required parameter "upsertFinancialSummaryRequest" was null or undefined when calling upsertClaimFinancialSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/financials/summary`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertFinancialSummaryRequestToJSON(requestParameters['upsertFinancialSummaryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimFinancialSummaryFromJSON(jsonValue));
    }

    /**
     * Upserts the claim\'s financial summary. If it doesn\'t exist, creates it. If it does, updates the provided fields.
     * Create or update the financial summary for a claim
     */
    async upsertClaimFinancialSummary(requestParameters: UpsertClaimFinancialSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFinancialSummary> {
        const response = await this.upsertClaimFinancialSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
